/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		8: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"chunk-contactme","1":"chunk-","2":"chunk-multi-agree-card","3":"chunk-time-selector","4":"chunk-yes-no-card","5":"chunk-svg-chooser","6":"chunk-radios-card","7":"chunk-input-card"}[chunkId]||chunkId) + ".chunk." + {"0":"38364","1":"3f10c","2":"54cba","3":"47514","4":"7d712","5":"aedd9","6":"4068c","7":"6a8d8"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/partner/moen/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/R+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createNewUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getQuestionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return postQuestionData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logging__ = __webpack_require__("GYD1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("DHvs");




var fetchRetried = __webpack_require__("7VMi");
var fetch = fetchRetried({
	delay: fetchRetried.exponential(100),
	retries: 5
});

var FIREBASE_API_URL = 'https://attn-labs-moen.firebaseio.com';

// POST => PUSH
// PUT => update value

// const OFFLINE = true;
var OFFLINE = false;

var getOfflineData = function getOfflineData(id) {
	switch (id) {
		case 'cq_2':
			return {
				"brush_teeth": 1,
				"coffee_tea": 2,
				"dont_know": 3,
				"drink_water": 4,
				"flush_toilet": 5,
				"shower_bath": 6,
				"total": 28,
				"wash_face": 7
			};
		case 'cq_3':
			return { "12-15": 201, "16+": 249, "5-7": 395, "8-11": 436, "<4": 238, "total": 1519 };
		case "cq_4":
			return {
				afternoon: 1,
				early_morning: 2,
				evening: 3,
				late_afternoon: 4,
				late_evening: 5,
				morning: 6,
				total: 21
			};
		case "cq_5_1":
		case "cq_5_2":
		case "cq_5_3":
		case "cq_5_4":
		case "cq_5_5":
		case "cq_5_6":
		case "cq_5_7":
		case "cq_5_8":
		case "cq_5_9":
		case "cq_5_10":
		case "cq_5_11":
		case "cq_5_12":
			return {
				strongly_disagree: 1,
				disagree: 2,
				agree: 3,
				strongly_agree: 4,
				total: 10
			};
		default:
			Object(__WEBPACK_IMPORTED_MODULE_0__logging__["a" /* log */])('no offline data case for ' + id);
			return {};
	}
};

var createNewUser = function createNewUser(userData) {
	return new Promise(function ($return, $error) {
		return $return(fetch(FIREBASE_API_URL + '/users.json', {
			method: 'POST',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			body: JSON.stringify(userData)
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			return response.name;
		}));
	});
};

var getQuestionData = function getQuestionData(questionId) {
	return new Promise(function ($return, $error) {
		// return new Promise( (resolve, reject) => {
		// 	setTimeout( () => {
		// 		// resolve(null);
		// 		// resolve(getOfflineData(questionId))
		// 		reject();
		// 	}, 2000);
		// })
		Object(__WEBPACK_IMPORTED_MODULE_0__logging__["a" /* log */])('getting getQuestionData', questionId, 'offline mode? ' + OFFLINE);
		if (OFFLINE) {
			var data = getOfflineData(questionId);
			Object(__WEBPACK_IMPORTED_MODULE_0__logging__["a" /* log */])('We are in offline mode, question ' + questionId + ' data: ' + data);
			return $return(data);
		} else {
			return $return(fetch(FIREBASE_API_URL + '/questions/' + questionId + '/counters.json', {
				method: 'GET',
				headers: {
					"Content-Type": "application/json; charset=utf-8"
				}
			}).then(function (response) {
				Object(__WEBPACK_IMPORTED_MODULE_0__logging__["a" /* log */])('successfully retrieved question ' + questionId + ' data');
				return response.json();
			}));
		}
		return $return();
	});
};

// const postUserQuestionData = async (questionId, voteId) => {
// 	let userId = getUserId();
// 	if(!userId) return;
// 	return fetch(`${FIREBASE_API_URL}/users/${userId}/votes.json`, {
// 		method: 'PUT',
// 		headers: {
// 			"Content-Type": "application/json; charset=utf-8",
// 		},
// 		body: JSON.stringify({
// 			[questionId]: voteId
// 		})
// 	})
// }

var postQuestionData = function postQuestionData(questionId, value) {
	return new Promise(function ($return, $error) {
		var userId = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* getUserId */])();
		if (userId) {
			fetch(FIREBASE_API_URL + '/questions/' + questionId + '/votes.json', {
				method: 'POST',
				headers: {
					"Content-Type": "application/json; charset=utf-8"
				},
				body: JSON.stringify({
					timestamp: new Date().getTime(),
					userId: userId,
					vote: value
				})
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				return response;
				// postUserQuestionData(questionId, response)
			}).catch(function (err) {
				return console.warn(err);
			});
		}
		return $return();
	});
};

/***/ }),

/***/ "/a1X":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac"), __webpack_require__("l262")(module)))

/***/ }),

/***/ "7VMi":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Backoff strategies
 */
function exponential(delay) {
    return function (attempts) {
        return attempts * attempts * delay;
    };
}

function binaryExponential() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return function (attempts) {
        return (Math.pow(2, attempts) - 1) * delay;
    };
}

function sleep(timeout) {
    if (timeout < 1) return Promise.resolve();

    return new Promise(function (resolve) {
        return setTimeout(resolve, timeout);
    });
}

/**
 * Retry logic
 */
function fetchRetried() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$delay = config.delay,
        delay = _config$delay === undefined ? 30 * 1000 : _config$delay,
        _config$retries = config.retries,
        retries = _config$retries === undefined ? 5 : _config$retries,
        _config$isOK = config.isOK,
        isOK = _config$isOK === undefined ? function (resp) {
        return resp.ok;
    } : _config$isOK,
        _config$shouldRetryEr = config.shouldRetryError,
        shouldRetryError = _config$shouldRetryEr === undefined ? function () {
        return true;
    } : _config$shouldRetryEr,
        _config$retryMethods = config.retryMethods,
        retryMethods = _config$retryMethods === undefined ? ['PUT', 'DELETE', 'GET', 'HEAD', 'PATCH', 'OPTIONS'] : _config$retryMethods;


    var _fetch = config.fetch || __webpack_require__("bZpv");

    var timeout = typeof delay === 'function' ? delay : exponential(delay);

    function shouldRetry(url, options, attempts) {
        var _ref = options || {},
            _ref$method = _ref.method,
            method = _ref$method === undefined ? 'GET' : _ref$method;

        if (retryMethods.indexOf(method.toUpperCase()) < 0) return false;

        if (attempts >= retries) return false;

        return true;
    }

    function execute(url, options) {
        var attempts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

        var wait = timeout(attempts);

        return sleep(wait).then(function () {
            return _fetch(url, options);
        }).then(function (resp) {
            if (!shouldRetry(url, options, attempts)) return resp;

            if (isOK(resp)) return resp;

            return execute(url, options, attempts + 1);
        }, function (error) {
            if (!shouldRetry(url, options, attempts)) throw error;

            if (!shouldRetryError(error)) throw error;

            return execute(url, options, attempts + 1);
        });
    }

    return function fetch(url, options) {
        // protect the `attempts` parameter
        return execute(url, options);
    };
}

fetchRetried.exponential = exponential;
fetchRetried.binaryExponential = binaryExponential;

module.exports = fetchRetried;

/***/ }),

/***/ "7XwE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageScroller; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isequal__ = __webpack_require__("/a1X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isnil__ = __webpack_require__("E2Vf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isnil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isnull__ = __webpack_require__("LJE0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isnull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isnull__);
var _class, _temp2;



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ANIMATION_TIMER = 200;
var KEY_UP = 38;
var KEY_DOWN = 40;

var TRANSLATION_AMOUNT = -100;

var PageScroller = (_temp2 = _class = function (_Component) {
    _inherits(PageScroller, _Component);

    function PageScroller() {
        var _temp, _this, _ret;

        _classCallCheck(this, PageScroller);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            componentIndex: 0,
            componentsToRender: [],
            containerHeight: typeof window === 'object' ? window.innerHeight : 0
        }, _this.previousTouchMove = null, _this.scrolling = false, _this.getPageClass = function () {
            return 'page ' + (_this.props.overflow ? 'overflow' : '');
        }, _this.componentDidMount = function () {
            window.addEventListener('resize', _this.onWindowResized);

            document.ontouchmove = function (event) {
                event.preventDefault();
            };

            _this._pageContainer.addEventListener("wheel", _this.wheelScroll);
            _this._pageContainer.addEventListener("touchmove", _this.touchMove);
            _this._pageContainer.addEventListener("keydown", _this.keyPress);

            var componentsToRender = [];

            if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(_this.props.children[_this.state.componentIndex])) {
                componentsToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    { key: _this.state.componentIndex, ref: function ref(c) {
                            return _this["container_" + _this.state.componentIndex] = c;
                        },
                        style: { height: "100%", width: "100%" },
                        className: _this.getPageClass()
                    },
                    _this.props.children[_this.state.componentIndex]
                ));
            } else {
                componentsToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    { ref: function ref(c) {
                            return _this["container_" + _this.state.componentIndex] = c;
                        },
                        style: { height: "100%", width: "100%" },
                        className: _this.getPageClass()
                    },
                    _this.props.children
                ));
            }

            _this.addNextComponent(componentsToRender);
        }, _this.componentWillUnmount = function () {
            window.removeEventListener('resize', _this.onWindowResized);

            _this._pageContainer.removeEventListener("wheel", _this.wheelScroll);
            _this._pageContainer.removeEventListener("touchmove", _this.touchMove);
            _this._pageContainer.removeEventListener("keydown", _this.keyPress);
        }, _this.goToPage = function (number) {
            var _this$props = _this.props,
                pageOnChange = _this$props.pageOnChange,
                children = _this$props.children;
            var componentIndex = _this.state.componentIndex;


            var componentsToRender = [].concat(_this.state.componentsToRender);

            if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isequal___default()(componentIndex, number)) {
                if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(_this["container_" + number]) && !_this.scrolling) {

                    _this.scrolling = true;
                    _this._pageContainer.style.transform = 'translate3d(0, ' + number * TRANSLATION_AMOUNT + '%, 0)';

                    if (pageOnChange) {
                        pageOnChange(number + 1);
                    }

                    if (__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(_this["container_" + (number + 1)]) && !__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(children[number + 1])) componentsToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'div',
                        { key: number + 1,
                            ref: function ref(c) {
                                return _this["container_" + (number + 1)] = c;
                            },
                            style: { height: "100%", width: "100%" },
                            className: _this.getPageClass()
                        },
                        children[number + 1]
                    ));

                    setTimeout(function () {
                        _this.setState({ componentIndex: number, componentsToRender: componentsToRender }, function () {
                            _this.scrolling = false;
                            _this.previousTouchMove = null;
                        });
                    }, _this.props.animationTimer + ANIMATION_TIMER);
                } else if (!_this.scrolling && !__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(children[number])) {

                    var componentsLength = componentsToRender.length;

                    var _loop = function _loop(i) {
                        componentsToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                            'div',
                            { key: i,
                                ref: function ref(c) {
                                    return _this["container_" + i] = c;
                                },
                                style: { height: "100%", width: "100%" },
                                className: _this.getPageClass()
                            },
                            children[i]
                        ));
                    };

                    for (var i = componentsLength; i <= number; i++) {
                        _loop(i);
                    }

                    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(children[number + 1])) {
                        componentsToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                            'div',
                            { key: number + 1,
                                ref: function ref(c) {
                                    return _this["container_" + (number + 1)] = c;
                                },
                                style: { height: "100%", width: "100%" },
                                className: _this.getPageClass()
                            },
                            children[number + 1]
                        ));
                    }

                    _this.scrolling = true;
                    _this.setState({
                        componentsToRender: componentsToRender
                    }, function () {
                        _this._pageContainer.style.transform = 'translate3d(0, ' + number * TRANSLATION_AMOUNT + '%, 0)';

                        if (pageOnChange) {
                            pageOnChange(number + 1);
                        }

                        setTimeout(function () {
                            _this.setState({ componentIndex: number }, function () {
                                _this.scrolling = false;
                                _this.previousTouchMove = null;
                            });
                        }, _this.props.animationTimer + ANIMATION_TIMER);
                    });
                }
            }
        }, _this.wheelScroll = function (event) {
            if (event.deltaY < 0) {
                _this.scrollWindowUp();
            } else {
                _this.scrollWindowDown();
            }
        }, _this.touchMove = function (event) {
            if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isnull___default()(_this.previousTouchMove)) {
                if (event.touches[0].clientY > _this.previousTouchMove) {
                    _this.scrollWindowUp();
                } else {
                    _this.scrollWindowDown();
                }
            } else {
                _this.previousTouchMove = event.touches[0].clientY;
            }
        }, _this.keyPress = function (event) {
            if (__WEBPACK_IMPORTED_MODULE_1_lodash_isequal___default()(event.keyCode, KEY_UP)) {
                _this.scrollWindowUp();
            }
            if (__WEBPACK_IMPORTED_MODULE_1_lodash_isequal___default()(event.keyCode, KEY_DOWN)) {
                _this.scrollWindowDown();
            }
        }, _this.onWindowResized = function () {
            _this.setState({ containerHeight: window.innerHeight });
            _this.forceUpdate();
        }, _this.addNextComponent = function (onMountedComponents) {
            var componentsToRender = [];

            if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(onMountedComponents)) {
                componentsToRender = [].concat(onMountedComponents);
            }

            componentsToRender = [].concat(componentsToRender, _this.state.componentsToRender);

            if (!componentsToRender[_this.state.componentIndex + 1]) {
                if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(_this.props.children[_this.state.componentIndex + 1])) {
                    componentsToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'div',
                        { key: _this.state.componentIndex + 1,
                            ref: function ref(c) {
                                return _this["container_" + (_this.state.componentIndex + 1)] = c;
                            },
                            style: { height: "100%", width: "100%" },
                            className: _this.getPageClass()
                        },
                        _this.props.children[_this.state.componentIndex + 1]
                    ));
                }
            }

            _this.setState({ componentsToRender: [].concat(componentsToRender) });
        }, _this.scrollWindowUp = function () {
            if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(_this["container_" + (_this.state.componentIndex - 1)]) && !_this.scrolling) {

                _this.scrolling = true;
                _this._pageContainer.style.transform = 'translate3d(0, ' + (_this.state.componentIndex - 1) * TRANSLATION_AMOUNT + '%, 0)';

                if (_this.props.pageOnChange) {
                    _this.props.pageOnChange(_this.state.componentIndex);
                }

                setTimeout(function () {
                    _this.setState(function (prevState) {
                        return { componentIndex: prevState.componentIndex - 1 };
                    }, function () {
                        _this.scrolling = false;
                        _this.previousTouchMove = null;
                    });
                }, _this.props.animationTimer + ANIMATION_TIMER);
            } else if (_this.props.scrollUnavailable) {
                _this.props.scrollUnavailable();
            }
        }, _this.scrollWindowDown = function () {
            if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isnil___default()(_this["container_" + (_this.state.componentIndex + 1)]) && !_this.scrolling) {

                _this.scrolling = true;
                _this._pageContainer.style.transform = 'translate3d(0, ' + (_this.state.componentIndex + 1) * TRANSLATION_AMOUNT + '%, 0)';

                if (_this.props.pageOnChange) {
                    _this.props.pageOnChange(_this.state.componentIndex + 2);
                }

                setTimeout(function () {
                    _this.setState(function (prevState) {
                        return { componentIndex: prevState.componentIndex + 1 };
                    }, function () {
                        _this.scrolling = false;
                        _this.previousTouchMove = null;
                        _this.addNextComponent();
                    });
                }, _this.props.animationTimer + ANIMATION_TIMER);
            } else if (_this.props.scrollUnavailable) {
                _this.props.scrollUnavailable();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    PageScroller.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            animationTimer = _props.animationTimer,
            transitionTimingFunction = _props.transitionTimingFunction,
            containerWidth = _props.containerWidth;
        var containerHeight = this.state.containerHeight;


        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { style: { height: containerHeight, width: containerWidth, overflow: "hidden" }, className: 'page-scroller' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { ref: function ref(c) {
                        return _this2._pageContainer = c;
                    },
                    style: {
                        height: "100%",
                        width: "100%",
                        transition: 'transform ' + animationTimer + 'ms ' + transitionTimingFunction
                    },
                    tabIndex: 0 },
                this.state.componentsToRender
            )
        );
    };

    return PageScroller;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
    animationTimer: 1000,
    transitionTimingFunction: "ease-in-out",
    containerHeight: typeof window === 'object' ? window.innerHeight : 0,
    containerWidth: "100%"
}, _temp2);


/***/ }),

/***/ "Cvo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__glyphs__ = __webpack_require__("OM1O");



var Loader = function Loader() {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ className: 'loader fill' },
		Object(__WEBPACK_IMPORTED_MODULE_1__glyphs__["a" /* getGlyph */])('loader')
	);
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),

/***/ "DHvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAgreementLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shuffle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return processData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logging__ = __webpack_require__("GYD1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isempty__ = __webpack_require__("Lump");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isempty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isempty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("mV6u");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var getUserId = function getUserId() {
	return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* USER_ID */]);
};

var getAgreementLabel = function getAgreementLabel(key) {
	var needle = __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* AGREE_OPTIONS */].find(function (o) {
		return o.value === key;
	});
	return needle ? needle.label : '';
};

var shuffle = function shuffle(arr) {
	var i = void 0,
	    temp = void 0,
	    j = void 0,
	    len = arr.length;
	for (i = 0; i < len; i++) {
		j = ~~(Math.random() * len);
		temp = arr[i];
		arr[i] = arr[j];
		arr[j] = temp;
	}
	return arr;
};

var largestRemainderRound = function largestRemainderRound(numbers, desiredTotal) {
	var result = numbers.map(function (number, index) {
		return {
			floor: Math.floor(number),
			remainder: getRemainder(number),
			index: index
		};
	}).sort(function (a, b) {
		return b.remainder - a.remainder;
	});

	var lowerSum = result.reduce(function (sum, current) {
		return sum + current.floor;
	}, 0);

	var delta = desiredTotal - lowerSum;
	for (var i = 0; i < delta; i++) {
		result[i].floor += 1;
	}
	return result.sort(function (a, b) {
		return a.index - b.index;
	}).map(function (result) {
		return result.floor;
	});
};

var getRemainder = function getRemainder(number) {
	var remainder = number - Math.floor(number);
	return remainder.toFixed(4);
};

var processData = function processData(question, data) {

	if (__WEBPACK_IMPORTED_MODULE_1_lodash_isempty___default()(data)) return;

	var total = data['total'];
	delete data['total'];

	var parsedData = Object.keys(data).reduce(function (acc, key) {
		var label = void 0;
		try {
			// laziness
			if ('agree' in data) {
				label = getAgreementLabel(key);
			} else {
				label = question.options.find(function (option) {
					return option.value === key;
				}).label;
			}
		} catch (err) {
			Object(__WEBPACK_IMPORTED_MODULE_0__logging__["a" /* log */])('no label found for question:' + question.id + ', key:' + key);
		}
		acc.push({
			name: key,
			value: total > 0 ? data[key] / total * 100 : 0,
			label: label
		});
		return acc;
	}, []);

	// ensure we dont go over 100%!
	var percents = largestRemainderRound(parsedData.map(function (point) {
		return point.value;
	}), 100);
	parsedData = parsedData.map(function (point, index) {
		return _extends({}, point, { value: percents[index] });
	});

	if (question.sortOrder) {
		var _ret = function () {
			Object(__WEBPACK_IMPORTED_MODULE_0__logging__["a" /* log */])('we has sortOrder', question.sortOrder);
			var sortedData = [];
			var order = question.sortOrder.slice();
			while (order.length) {
				sortedData.push(parsedData.find(function (point) {
					return point.name === order[0];
				}));
				order.shift();
			}
			Object(__WEBPACK_IMPORTED_MODULE_0__logging__["a" /* log */])('sortedData', sortedData);
			return {
				v: sortedData
			};
		}();

		if (typeof _ret === "object") return _ret.v;
	}
	return parsedData;
};

/***/ }),

/***/ "E2Vf":
/***/ (function(module, exports) {

/**
 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;

/***/ }),

/***/ "GYD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return log; });
var DEBUG = false;
// const DEBUG = true;

var log = function log() {
	var _console;

	if (!DEBUG) return;
	(_console = console).warn.apply(_console, arguments);
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.scss
var style = __webpack_require__("yY49");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/loader/index.js
var loader = __webpack_require__("Cvo2");

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__("mV6u");

// EXTERNAL MODULE: ./components/page-scroller/index.js
var page_scroller = __webpack_require__("7XwE");

// EXTERNAL MODULE: ./components/lazy-background/index.js
var lazy_background = __webpack_require__("ukFb");

// EXTERNAL MODULE: ./components/glyphs/index.js
var glyphs = __webpack_require__("OM1O");

// CONCATENATED MODULE: ./components/welcome/index.js







var _ref = Object(preact_min["h"])(lazy_background["a" /* default */], { image: 'assets/splash-min.jpg', overlay: true });

var _ref2 = Object(preact_min["h"])(
	'div',
	{ className: 'content' },
	Object(preact_min["h"])(
		'h2',
		null,
		'How does your relationship with water impact your daily life?'
	),
	Object(preact_min["h"])(
		'h3',
		null,
		'See how you compare in Moen\'s water census survey.'
	)
);

var _ref3 = Object(preact_min["h"])('div', { className: 'line' });

var welcome_Welcome = function Welcome(props) {
	return Object(preact_min["h"])(
		'div',
		{ className: 'welcome' },
		_ref,
		Object(glyphs["a" /* getGlyph */])('logo'),
		_ref2,
		Object(preact_min["h"])(
			'div',
			{ className: 'cta' },
			Object(preact_min["h"])(
				'button',
				{ onClick: function onClick() {
						return props.next();
					} },
				'Take the Survey'
			),
			_ref3
		)
	);
};

/* harmony default export */ var welcome = (welcome_Welcome);
// EXTERNAL MODULE: ./components/fade-card/index.js
var fade_card = __webpack_require__("ljlK");

// CONCATENATED MODULE: ./components/cards/option-card/index.js



var option_card_OptionCard = function OptionCard(props) {
	var question = props.question,
	    submitting = props.submitting,
	    id = props.id,
	    active = props.active,
	    options = props.options,
	    index = props.index,
	    next = props.next,
	    set = props.set,
	    lastCard = props.lastCard;

	return Object(preact_min["h"])(
		"div",
		{ className: "option-card" },
		Object(preact_min["h"])(
			"h2",
			null,
			question
		),
		Object(preact_min["h"])(
			"div",
			{ className: "slide-options options" },
			options.map(function (option) {
				return Object(preact_min["h"])(
					"div",
					{ className: "option" },
					Object(preact_min["h"])("input", {
						disabled: submitting,
						name: "option-" + index,
						type: "radio",
						id: option.value,
						value: option.value,
						"class": "hide",
						onChange: function onChange(e) {
							return set(id, e.target.value);
						}
					}),
					Object(preact_min["h"])(
						"label",
						{ "for": option.value },
						option.label
					)
				);
			})
		),
		Object(preact_min["h"])(
			"button",
			{ disabled: !active || submitting, onClick: next },
			lastCard ? submitting ? 'Finishing' : 'Finish' : 'Submit'
		)
	);
};

/* harmony default export */ var option_card = (option_card_OptionCard);
// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__("/R+W");

// EXTERNAL MODULE: ./utils/tracking.js
var tracking = __webpack_require__("x4D6");

// CONCATENATED MODULE: ./components/intro/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var WELCOME_MESSAGE = 'Before we get our feet wet, we\'d love to know a little about you!';

var OPTIONS = [{
	question: 'What is your gender?',
	id: 'gender',
	options: [{ label: 'Male', value: 'male' }, { label: 'Female', value: 'female' }, { label: 'Prefer not to answer', value: 'na' }],
	gtmCode: 'demo_gender_visit'
}, {
	question: 'How old are you?',
	id: 'age',
	options: [{ label: '18-24', value: '18-24' }, { label: '25-37', value: '25-37' }, { label: '38-52', value: '38-52' }, { label: '53-66', value: '53-66' }],
	gtmCode: 'demo_age_visit'
}, {
	question: 'What region are you from?',
	id: 'region',
	options: [{ label: 'West', value: 'west' }, { label: 'Mountain', value: 'mountain' }, { label: 'Central', value: 'central' }, { label: 'East', value: 'east' }],
	gtmCode: 'demo_region_visit'
}];

var intro__ref = Object(preact_min["h"])(lazy_background["a" /* default */], { image: 'assets/intro-min.jpg' });

var intro__ref2 = Object(preact_min["h"])(
	'h1',
	null,
	WELCOME_MESSAGE
);

var intro_Intro = function (_Component) {
	_inherits(Intro, _Component);

	function Intro() {
		var _temp, _this, _ret;

		_classCallCheck(this, Intro);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			submitting: false
		}, _this.data = {}, _this.set = function (id, value) {
			var _this$setState;

			_this.setState((_this$setState = {}, _this$setState[id] = value, _this$setState));
		}, _this.goToNext = function () {
			return _this.fadeCard.nextCard();
		}, _this.submit = function () {
			return new Promise(function ($return, $error) {
				var userId, userData, newUserId;

				// disable spam clicking
				if (!_this.state.submitting) {
					_this.setState({ submitting: true });
					userId = localStorage.getItem(constants["e" /* USER_ID */]);

					userData = Object.keys(_this.state).reduce(function (data, key) {
						if (key !== 'submitting') {
							data[key] = _this.state[key];
						}
						return data;
					}, {});
					return Promise.resolve(Object(api["a" /* createNewUser */])(userData)).then(function ($await_2) {
						try {
							newUserId = $await_2;
							localStorage.setItem(constants["e" /* USER_ID */], newUserId);
							window.moen_social_tracking.event("Moen - Water Census Survey - Started");
							_this.props.finish();
							// }
							//
							return $If_1.call(this);
						} catch ($boundEx) {
							return $error($boundEx);
						}
					}.bind(this), $error);
				}

				function $If_1() {
					return $return();
				}

				return $If_1.call(this);
			});
		}, _this.cardChange = function (index, max) {
			if (max - 1 === index) {
				return;
			}
			var event = OPTIONS[index + 1].gtmCode;
			Object(tracking["b" /* trackScreen */])(event);
			// trackEvent();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Intro.prototype.render = function render() {
		var _this2 = this;

		var handleChange = this.handleChange,
		    set = this.set,
		    submit = this.submit;
		var _state = this.state,
		    selected = _state.selected,
		    submitting = _state.submitting;

		return Object(preact_min["h"])(
			'div',
			{ className: 'intro-card' },
			intro__ref,
			Object(preact_min["h"])(
				'div',
				{ className: 'content-card' },
				intro__ref2,
				Object(preact_min["h"])(
					fade_card["a" /* default */],
					{
						ref: function ref(node) {
							return _this2.fadeCard = node;
						},
						counter: true,
						counterDelimiter: 'of',
						finish: submit,
						change: this.cardChange
					},
					OPTIONS.map(function (option, index) {
						return Object(preact_min["h"])(option_card, {
							id: option.id,
							index: index,
							question: option.question,
							options: option.options,
							next: _this2.goToNext,
							set: set,
							submitting: submitting,
							active: _this2.state[option.id]
						});
					})
				)
			)
		);
	};

	return Intro;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/start/index.js


function start__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function start__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function start__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var start_Start = function (_Component) {
	start__inherits(Start, _Component);

	function Start() {
		var _temp, _this, _ret;

		start__classCallCheck(this, Start);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = start__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.takeSurvey = function () {
			Object(tracking["a" /* trackButtonClick */])('Take Survey');
			Object(tracking["b" /* trackScreen */])('demo_gender_visit');
			// trackEvent('take_survey_button_click');
			// trackEvent('demo_gender_visit');
			_this.pageScroller.goToPage(1);
		}, _this.goToPage = function (pageNumber) {
			return _this.pageScroller.goToPage(pageNumber);
		}, _temp), start__possibleConstructorReturn(_this, _ret);
	}

	Start.prototype.componentDidMount = function componentDidMount() {
		Object(tracking["b" /* trackScreen */])('landing_page_visit');
		// trackEvent('landing_page_visit');
		// begin preloading background images
		var images = constants["c" /* QUESTIONS */].filter(function (question) {
			return 'image' in question;
		}).map(function (question) {
			return question.image;
		});
		images = ['splash-min.jpg', 'intro-min.jpg', 'splash-min.jpg'].concat(images);
		images.forEach(function (question) {
			var image = new Image();
			image.src = 'assets/' + question.image;
		});
	};

	Start.prototype.render = function render() {
		var _this2 = this;

		return Object(preact_min["h"])(
			page_scroller["a" /* default */],
			{
				ref: function ref(c) {
					return _this2.pageScroller = c;
				},
				overflow: true
			},
			Object(preact_min["h"])(welcome, { next: this.takeSurvey }),
			Object(preact_min["h"])(intro_Intro, { finish: this.props.startComplete })
		);
	};

	return Start;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import Loadable from 'preact-loadable';

// import Questions from './questions';




// let LoadableQuestions = new Loadable({
//   loader: () => import('./questions'),
//   LoadingComponent: Loader,
//   delay: 200,
//   webpackRequireWeakId: () => require.resolveWeak('./questions'),
// });

var app_App = function (_Component) {
	app__inherits(App, _Component);

	function App() {
		var _this2 = this;

		var _temp, _this, _ret;

		app__classCallCheck(this, App);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = app__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			startComplete: false,
			move: false,
			Questions: null
		}, _this.getClasses = function () {
			if (typeof navigator === 'object') {
				var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
				if (isSafari) {
					return 'safari';
				}
			}
		}, _this.startComplete = function () {
			_this.setState({ startComplete: true }, function () {
				return setTimeout(function () {
					return _this.setState({ move: true });
				}, 1000);
			});
		}, _this.getContent = function () {
			var _this$state = _this.state,
			    startComplete = _this$state.startComplete,
			    move = _this$state.move;

			if (constants["d" /* SKIP_START */] && _this.state.Questions) {
				return Object(preact_min["h"])(
					'div',
					{ id: 'app', className: _this.getClasses() },
					Object(preact_min["h"])(
						'div',
						{ className: 'questions-container ' + (move ? 'move' : '') },
						Object(preact_min["h"])(_this2.state.Questions, null)
					)
				);
			}
			var Questions = _this.state.Questions;
			return Object(preact_min["h"])(
				'div',
				{ id: 'app', className: _this.getClasses() },
				Object(preact_min["h"])(
					'div',
					{ className: 'start-container ' + (move ? 'move' : '') },
					Object(preact_min["h"])(start_Start, { startComplete: _this.startComplete })
				),
				startComplete && Object(preact_min["h"])(
					'div',
					{ className: 'questions-container ' + (move ? 'move' : '') },
					Object(preact_min["h"])(Questions, null)
				)
			);
		}, _temp), app__possibleConstructorReturn(_this, _ret);
	}

	App.prototype.componentDidMount = function componentDidMount() {
		return new Promise(function ($return, $error) {
			var questions;
			return Promise.resolve(__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "OG0I"))).then(function ($await_1) {
				try {
					questions = $await_1;
					this.setState({ Questions: questions.default });
					return $return();
				} catch ($boundEx) {
					return $error($boundEx);
				}
			}.bind(this), $error);
		}.bind(this));
	};

	App.prototype.render = function render() {
		return this.getContent();
	};

	return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index_0 = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = M;for (i = arguments.length; i-- > 2;) {
      T.push(arguments[i]);
    }t && null != t.children && (T.length || T.push(t.children), delete t.children);while (T.length) {
      if ((o = T.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        T.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === M ? l = [o] : l.push(o), n = r;
    }var a = new S();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== L.vnode && L.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function o(e) {
    !e.__d && (e.__d = !0) && 1 == D.push(e) && (L.debounceRendering || P)(r);
  }function r() {
    var e,
        t = D;D = [];while (e = t.pop()) {
      e.__d && C(e);
    }
  }function i(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && l(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function l(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function a(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function p(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function s(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function u(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === W.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, c, l) : e.removeEventListener(t, c, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) {
        try {
          e[t] = null == o ? "" : o;
        } catch (e) {}null != o && !1 !== o || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var a = r && t !== (t = t.replace(/^xlink:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function c(e) {
    return this.__l[e.type](L.event && L.event(e) || e);
  }function _() {
    var e;while (e = E.pop()) {
      L.afterMount && L.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    V++ || (A = null != r && void 0 !== r.ownerSVGElement, H = null != e && !("__preactattr_" in e));var l = f(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --V || (H = !1, i || _()), l;
  }function f(e, t, n, o, r) {
    var i = e,
        a = A;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), m(e, !0))), i.__preactattr_ = !0, i;var s = t.nodeName;if ("function" == typeof s) return x(e, t, n, o);if (A = "svg" === s || "foreignObject" !== s && A, s += "", (!e || !l(e, s)) && (i = p(s, A), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), m(e, !0);
    }var u = i.firstChild,
        c = i.__preactattr_,
        _ = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var d = i.attributes, f = d.length; f--;) {
        c[d[f].name] = d[f].value;
      }
    }return !H && _ && 1 === _.length && "string" == typeof _[0] && null != u && void 0 !== u.splitText && null == u.nextSibling ? u.nodeValue != _[0] && (u.nodeValue = _[0]) : (_ && _.length || null != u) && h(i, _, n, o, H || null != c.dangerouslySetInnerHTML), b(i, t.attributes, c), A = a, i;
  }function h(e, t, n, o, r) {
    var l,
        a,
        p,
        u,
        c,
        _ = e.childNodes,
        d = [],
        h = {},
        v = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (v++, h[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (d[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      u = t[C], c = null;var k = u.key;if (null != k) v && void 0 !== h[k] && (c = h[k], h[k] = void 0, v--);else if (b < g) for (l = b; l < g; l++) {
        if (void 0 !== d[l] && i(a = d[l], u, r)) {
          c = a, d[l] = void 0, l === g - 1 && g--, l === b && b++;break;
        }
      }c = f(c, u, n, o), p = _[C], c && c !== e && c !== p && (null == p ? e.appendChild(c) : c === p.nextSibling ? s(p) : e.insertBefore(c, p));
    }if (v) for (var C in h) {
      void 0 !== h[C] && m(h[C], !1);
    }while (b <= g) {
      void 0 !== (c = d[g--]) && m(c, !1);
    }
  }function m(e, t) {
    var n = e._component;n ? N(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || s(e), v(e));
  }function v(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;m(e, !0), e = t;
    }
  }function b(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || u(e, o, n[o], n[o] = void 0, A);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || u(e, o, n[o], n[o] = t[o], A);
    }
  }function y(e, t, n) {
    var o,
        r = B.length;e.prototype && e.prototype.render ? (o = new e(t, n), k.call(o, t, n)) : (o = new k(t, n), o.constructor = e, o.render = g);while (r--) {
      if (B[r].constructor === e) return o.__b = B[r].__b, B.splice(r, 1), o;
    }return o;
  }function g(e, t, n) {
    return this.constructor(e, n);
  }function w(e, t, n, r, i) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, r)), r && r !== e.context && (e.__c || (e.__c = e.context), e.context = r), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === L.syncComponentUpdates && e.base ? o(e) : C(e, 1, i)), e.__r && e.__r(e));
  }function C(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          p,
          s = e.props,
          u = e.state,
          c = e.context,
          f = e.__p || s,
          h = e.__s || u,
          v = e.__c || c,
          b = e.base,
          g = e.__b,
          x = b || g,
          k = e._component,
          U = !1,
          S = v;if (e.constructor.getDerivedStateFromProps && (u = t(t({}, u), e.constructor.getDerivedStateFromProps(s, u)), e.state = u), b && (e.props = f, e.state = h, e.context = v, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(s, u, c) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(s, u, c), e.props = s, e.state = u, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(s, u, c), e.getChildContext && (c = t(t({}, c), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(f, h));var T,
            M,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = a(i);l = k, l && l.constructor === P && W.key == l.__k ? w(l, W, 1, c, !1) : (T = l, e._component = l = y(P, W, c), l.__b = l.__b || g, l.__u = e, w(l, W, 0, c, !1), C(l, 1, o, !0)), M = l.base;
        } else p = x, T = k, T && (p = e._component = null), (x || 1 === n) && (p && (p._component = null), M = d(p, i, c, o || !b, x && x.parentNode, !0));if (x && M !== x && l !== k) {
          var D = x.parentNode;D && M !== D && (D.replaceChild(M, x), T || (x._component = null, m(x, !1)));
        }if (T && N(T), e.base = M, M && !r) {
          var A = e,
              H = e;while (H = H.__u) {
            (A = H).base = M;
          }M._component = A, M._componentConstructor = A.constructor;
        }
      }!b || o ? E.unshift(e) : U || (e.componentDidUpdate && e.componentDidUpdate(f, h, S), L.afterUpdate && L.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }V || r || _();
    }
  }function x(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        p = r && e._componentConstructor === t.nodeName,
        s = p,
        u = a(t);while (r && !s && (r = r.__u)) {
      s = r.constructor === t.nodeName;
    }return r && s && (!o || r._component) ? (w(r, u, 3, n, o), e = r.base) : (i && !p && (N(i), e = l = null), r = y(t.nodeName, u, n), e && !r.__b && (r.__b = e, l = null), w(r, u, 1, n, o), e = r.base, l && e !== l && (l._component = null, m(l, !1))), e;
  }function N(e) {
    L.beforeUnmount && L.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? N(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, s(t), B.push(e), v(t)), e.__r && e.__r(null);
  }function k(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function U(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }var S = function S() {},
      L = {},
      T = [],
      M = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      W = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      D = [],
      E = [],
      V = 0,
      A = !1,
      H = !1,
      B = [];t(k.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), o(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), C(this, 2);
    }, render: function render() {} });var F = { h: e, createElement: e, cloneElement: n, Component: k, render: U, rerender: r, options: L }; true ? module.exports = F : self.preact = F;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "LJE0":
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;

/***/ }),

/***/ "Lump":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac"), __webpack_require__("l262")(module)))

/***/ }),

/***/ "OM1O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGlyph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 8 8", className: "icon" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M6.406 1l-.719.688-2.781 2.781-.781-.781-.719-.688-1.406 1.406.688.719 1.5 1.5.719.688.719-.688 3.5-3.5.688-.719-1.406-1.406z", className: "checkmark" })
);

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 8 8", className: "icon" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M1.406 0l-1.406 1.406.688.719 1.781 1.781-1.781 1.781-.688.719 1.406 1.406.719-.688 1.781-1.781 1.781 1.781.719.688 1.406-1.406-.688-.719-1.781-1.781 1.781-1.781.688-.719-1.406-1.406-.719.688-1.781 1.781-1.781-1.781-.719-.688z", className: "close" })
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 8 8", className: "icon" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M4.469 0c-.854 0-1.48.256-1.875.656s-.54.901-.594 1.281l1 .125c.036-.26.125-.497.313-.688.188-.19.491-.375 1.156-.375.664 0 1.019.163 1.219.344.199.181.281.405.281.656 0 .833-.313 1.063-.813 1.5-.5.438-1.188 1.083-1.188 2.25v.25h1v-.25c0-.833.344-1.063.844-1.5.5-.438 1.156-1.083 1.156-2.25 0-.479-.168-1.02-.594-1.406-.426-.387-1.071-.594-1.906-.594zm-.5 7v1h1v-1h-1z", className: "question-mark" })
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ className: "logo", viewBox: "0 0 528.08 116.4" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"title",
		null,
		"Moen"
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"g",
		null,
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", { points: "94.65 114.09 94.69 48.74 94.45 48.74 69.98 86.14 56.12 86.14 30.95 49.19 30.71 49.19 30.66 114.09 0 114.09 0 1.86 26.33 1.86 62.58 53.12 62.82 53.12 97.46 1.86 125.41 1.86 125.41 114.09 94.65 114.09" }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M205.08,23.79c-17.32,0-27.48,13.16-27.48,34.42S188,92.38,205.08,92.38c17.33,0,27.25-12.93,27.25-34.17s-10.16-34.42-27.25-34.42m40.65,79c-10.16,8.77-24,13.62-40.65,13.62-16.16,0-29.55-4.62-39.72-12.93C152.88,93.3,145.73,77.6,145.73,58.21c0-18.48,6.92-34.19,19.17-44.58C175.05,5.08,188.92,0,205.54,0,222.63,0,237,5.31,247.12,14.55,258.43,25,264.67,40,264.67,58.21,264.67,76.91,258,92.61,245.73,102.78Z" }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", { points: "354.05 24.95 315.47 24.95 315.47 46.19 354.05 46.19 354.05 68.14 315.47 68.14 315.47 91 359.59 91 359.59 114.09 284.99 114.09 284.99 1.86 361.66 1.86 354.05 24.95" }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("polyline", { points: "469.75 114.09 416.86 45.04 416.63 45.04 416.59 114.09 386.14 114.09 386.14 1.86 416.17 1.86 467.21 68.82 467.43 68.82 467.48 1.86 498.15 1.86 498.15 114.09 469.75 114.09" }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M517.29,23.22a10.77,10.77,0,1,1,10.79-10.78A10.75,10.75,0,0,1,517.29,23.22Zm0-19.76a9,9,0,1,0,9,9A9,9,0,0,0,517.29,3.46Zm-4.7,3.37h5.11c2.87,0,3.83,1.78,3.83,3a3.28,3.28,0,0,1-3.3,3.33v.06c1,.35,1.72,1.34,2.69,2.89l1.4,2.25H520l-1-1.81c-1.46-2.6-2-3.1-3.45-3.1h-1.11V18.4h-1.87Zm4.56,5.05c1.43,0,2.4-.55,2.4-1.75s-.85-1.72-2.08-1.72h-3v3.47Z" })
	)
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ version: "1.1", viewBox: "0 0 50 50", style: "enable-background:new 0 0 50 50;" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"path",
		{ d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z", transform: "rotate(89.6364 25 25)" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("animateTransform", { attributeType: "xml", attributeName: "transform", type: "rotate", from: "0 25 25", to: "360 25 25", dur: "0.6s", repeatCount: "indefinite" })
	)
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 82 48", version: "1.1" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"g",
		{ id: "Page-1", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			"g",
			{ id: "noun_bathe_1729881", fill: "#000000", "fill-rule": "nonzero" },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M70.684,24.074 L53.854,24.074 L8.634,24.074 L8.634,6.147 C8.634,4.116 10.287,2.464 12.319,2.464 C14.349,2.464 16.001,4.116 16.001,6.147 L18.001,6.147 C18.001,3.013 15.452,0.464 12.319,0.464 C9.185,0.464 6.634,3.013 6.634,6.147 L6.634,24.074 L0,24.074 L0,32.488 C0,40.786 6.751,47.536 15.049,47.536 L66.951,47.536 C75.249,47.536 82,40.786 82,32.488 L82,24.074 L70.684,24.074 Z M55.854,26.074 L68.684,26.074 L68.684,35.26 L55.854,35.26 L55.854,26.074 Z M55.854,37.26 L68.684,37.26 L68.684,40.167 L55.854,40.167 L55.854,37.26 Z M80,32.488 C80,39.682 74.146,45.536 66.951,45.536 L15.049,45.536 C7.854,45.536 2,39.683 2,32.488 L2,26.074 L53.854,26.074 L53.854,42.167 L70.684,42.167 L70.684,26.074 L80,26.074 L80,32.488 Z", id: "Shape" })
		)
	)
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 72 80", version: "1.1" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"g",
		{ id: "Page-1", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			"g",
			{ id: "noun_Dishwasher_539638", fill: "#000000", "fill-rule": "nonzero" },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				"g",
				{ id: "Group" },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M70.994,0.505 C70.863,0.375 70.683,0.3 70.5,0.3 L1.5,0.3 C1.314,0.3 1.135,0.375 1.004,0.505 C0.875,0.635 0.799,0.816 0.799,1 L0.799,79 C0.799,79.185 0.875,79.364 1.004,79.495 C1.135,79.625 1.315,79.7 1.5,79.7 L70.5,79.7 C70.684,79.7 70.863,79.625 70.994,79.495 C71.125,79.364 71.199,79.183 71.199,79 L71.199,1 C71.199,0.815 71.125,0.635 70.994,0.505 Z M69.799,15.3 L2.199,15.3 L2.199,1.7 L69.799,1.7 L69.799,15.3 Z M2.199,78.3 L2.199,16.7 L69.799,16.7 L69.799,78.3 L2.199,78.3 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M45,22.3 L27,22.3 C26.613,22.3 26.299,22.613 26.299,23 C26.299,23.387 26.613,23.7 27,23.7 L45,23.7 C45.387,23.7 45.699,23.387 45.699,23 C45.699,22.613 45.387,22.3 45,22.3 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M29.004,11.495 C29.135,11.625 29.315,11.7 29.5,11.7 L42.5,11.7 C42.684,11.7 42.863,11.625 42.994,11.495 C43.125,11.364 43.199,11.183 43.199,11 L43.199,6 C43.199,5.815 43.125,5.635 42.994,5.505 C42.863,5.375 42.684,5.3 42.5,5.3 L29.5,5.3 C29.314,5.3 29.135,5.375 29.004,5.505 C28.875,5.635 28.799,5.816 28.799,6 L28.799,11 C28.799,11.185 28.875,11.364 29.004,11.495 Z M30.199,6.699 L41.799,6.699 L41.799,10.3 L30.199,10.3 L30.199,6.699 Z", id: "Shape" })
			)
		)
	)
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 75 80", version: "1.1" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"g",
		{ id: "Page-1", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			"g",
			{ id: "noun_Hose_1797480", fill: "#000000", "fill-rule": "nonzero" },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M37,25.125 C30.7070312,25.125 25.5878906,30.2446289 25.5878906,36.5371094 C25.5878906,42.8300782 30.7070312,47.9497071 37,47.9497071 C43.2929688,47.9497071 48.4121094,42.8300782 48.4121094,36.5371094 C48.4121094,30.2446289 43.2929688,25.125 37,25.125 Z M37,45.949707 C31.8105469,45.949707 27.5878906,41.7270508 27.5878906,36.5371093 C27.5878906,31.3471678 31.8105469,27.125 37,27.125 C42.1894531,27.125 46.4121094,31.347168 46.4121094,36.5371094 C46.4121094,41.7270508 42.1894531,45.949707 37,45.949707 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M73.5,65.2750244 L73.5,36.5371094 C73.5,16.4111328 57.1259766,0.0371094 37,0.0371094 C16.8740234,0.0371094 0.5,16.4111328 0.5,36.5371094 C0.5,56.663086 16.8740234,73.0371094 37,73.0371094 C45.9559326,73.0371094 54.4503784,69.815857 61.1210938,63.9308472 L61.1210938,65.2758179 C60.6318359,65.3411865 60.2490234,65.743103 60.2490234,66.25 L60.2490234,71.75 C60.2490234,72.3022461 60.696289,72.75 61.2490234,72.75 L62.8736572,72.75 L63.821289,79.1464844 C63.8935547,79.6367188 64.3144531,80 64.8105469,80 L69.8144531,80 C70.3105469,80 70.7314453,79.6367188 70.8037109,79.1464844 L71.7513428,72.75 L73.3759766,72.75 C73.928711,72.75 74.3759766,72.3022461 74.3759766,71.75 L74.3759766,66.25 C74.3759766,65.7416992 73.9912109,65.3386841 73.5,65.2750244 Z M37,10.4160156 C22.5966797,10.4160156 10.8789062,22.133789 10.8789062,36.5371094 C10.8789062,50.9404298 22.5966797,62.6582031 37,62.6582031 C47.8562622,62.6582031 57.1838379,55.9996948 61.1210938,46.5532837 L61.1210938,61.2176514 C61.1071778,61.2296753 61.0894776,61.2336426 61.0761719,61.2465821 C54.5986328,67.5600586 46.0478516,71.0371094 37,71.0371094 C17.9765625,71.0371094 2.5,55.5605469 2.5,36.5371094 C2.5,17.5136719 17.9765625,2.0371094 37,2.0371094 C56.0234375,2.0371094 71.5,17.5136719 71.5,36.5371094 L71.5,65.25 L63.1210938,65.25 L63.1210938,36.5371094 C63.1210938,22.1337891 51.4033203,10.4160156 37,10.4160156 Z M61.1210938,36.5371094 C61.1210938,49.8374024 50.3007813,60.6582032 37,60.6582032 C23.6992187,60.6582032 12.8789062,49.8374023 12.8789062,36.5371094 C12.8789062,23.2368165 23.6992188,12.4160156 37,12.4160156 C50.3007812,12.4160156 61.1210938,23.2368164 61.1210938,36.5371094 Z M68.9521484,78 L65.6728515,78 L64.8955077,72.75 L69.7294921,72.75 L68.9521484,78 Z M72.3759766,70.75 L62.2490234,70.75 L62.2490234,67.25 L72.3759766,67.25 L72.3759766,70.75 Z", id: "Shape" })
		)
	)
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 90 70", version: "1.1" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"g",
		{ id: "Page-1", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			"g",
			{ id: "noun_tap_1625926", fill: "#000000", "fill-rule": "nonzero" },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				"g",
				{ id: "Group" },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M89.172,36.25 L84.73,26.208 C84.116,24.827 82.743,23.933 81.228,23.933 C81.029,23.933 80.827,23.949 80.63,23.98 L34.268,31.379 L34.268,23.044 L36.368,23.044 L36.368,14.106 C38.466,13.54 45.693,11.574 52.816,9.482 C70.513,4.286 70.371,3.51 70.19,2.528 C69.938,1.155 68.483,0.334 66.296,0.334 C66.173,0.334 66.1,0.338 66.089,0.338 C63.838,0.471 10.891,3.618 6.089,5.401 C0.909,7.325 0.516,12.75 0.5,13.031 L0.5,23.042 L2.827,23.042 L2.827,69.662 L34.267,69.662 L34.267,52.676 L66.64,41.364 L67.274,42.635 C67.927,43.939 69.235,44.748 70.691,44.748 C70.954,44.748 71.217,44.722 71.475,44.667 L86.457,41.539 C87.593,41.302 88.547,40.575 89.078,39.541 C89.605,38.511 89.641,37.311 89.172,36.25 Z M2.125,21.419 L2.124,13.083 C2.127,13.037 2.457,8.488 6.655,6.928 C10.316,5.568 47.196,3.086 66.173,1.964 L66.296,1.963 C66.912,1.963 68.008,2.088 68.429,2.524 C65.869,4.063 49.862,8.81 35.344,12.7 L34.741,12.862 L34.741,21.421 L34.267,21.421 L2.827,21.421 L2.125,21.421 L2.125,21.419 Z M87.631,38.801 C87.328,39.394 86.778,39.812 86.125,39.947 L71.143,43.075 C70.185,43.277 69.165,42.78 68.73,41.908 L67.457,39.356 L33.475,51.229 C33.436,51.244 33.395,51.25 33.356,51.26 L32.643,51.43 L32.643,68.037 L4.453,68.037 L4.453,23.044 L32.642,23.044 L32.642,33.286 L80.885,25.586 C81.864,25.433 82.843,25.969 83.241,26.867 L87.684,36.908 C87.953,37.518 87.935,38.209 87.631,38.801 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M80.844,46.611 L80.344,46.221 L79.845,46.611 C72.76,52.134 73.09,59.879 73.107,60.161 C73.107,64.153 76.354,67.399 80.344,67.399 C84.335,67.399 87.582,64.153 87.582,60.205 C87.599,59.879 87.928,52.135 80.844,46.611 Z M85.957,60.161 C85.957,63.256 83.438,65.774 80.344,65.774 C77.25,65.774 74.732,63.255 74.732,60.119 C74.727,60.051 74.464,53.258 80.344,48.299 C86.225,53.258 85.96,60.051 85.957,60.161 Z", id: "Shape" })
			)
		)
	)
);

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 66 74", version: "1.1" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"g",
		{ id: "Page-1", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			"g",
			{ id: "noun_Water_1511790", fill: "#000000", "fill-rule": "nonzero" },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M17.56,73.91 L39.56,73.91 C48.9488407,73.91 56.56,66.2988407 56.56,56.91 L56.56,47 L0.6,47 L0.6,57 C0.64941211,66.3380927 8.2218021,73.8881584 17.56,73.91 Z M2.23,48.59 L54.86,48.59 L54.86,57 C54.821507,65.4424244 47.9725051,72.2690877 39.53,72.28 L17.53,72.28 C9.09920509,72.2526254 2.26840238,65.4307519 2.23,57 L2.23,48.59 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M64.59,0.09 L59.18,0.09 C57.5812643,0.217335579 56.2278232,1.31999198 55.78,2.86 L53.47,9.8 L42.82,8.62 L42.82,5.88 L47.48,5.88 C50.68,5.88 50.85,0.93 47.85,0.93 L33.93,0.93 C31.05,0.93 31.04,5.88 34.05,5.88 L38.42,5.88 L38.42,8.62 L27.24,9.87 C25.8800415,10.0156109 24.8609048,11.1828273 24.9,12.55 L25.17,16.16 C25.3,17.8 25.61,21.88 25.59,21.62 C25.6734766,22.7020046 26.5747819,23.5379979 27.66,23.54 L30.24,23.54 C31.3903811,23.5400132 32.3244958,22.610368 32.33,21.46 L32.33,17.39 L40.62,18.3 L53.4,16.88 L55.8,23.29 C56.2584477,24.804975 57.6015926,25.8818752 59.18,26 L64.59,26 C65.0389634,25.9945244 65.4000334,25.6289968 65.4,25.18 L65.4,0.91 C65.4026737,0.693447258 65.3185164,0.484842239 65.1663212,0.330768061 C65.014126,0.176693883 64.8065692,0.0899834951 64.59,0.09 Z M33.43,3.62 L33.43,3.07 C33.4299466,2.79219425 33.6522477,2.56544717 33.93,2.56 L47.85,2.56 C47.9852604,2.56 48.1149809,2.61373199 48.2106245,2.70937554 C48.306268,2.80501909 48.36,2.93473959 48.36,3.07 L48.36,3.36 C48.3627079,3.59421015 48.2708637,3.81961839 48.105241,3.98524104 C47.9396184,4.1508637 47.7142102,4.2427079 47.48,4.24 L34.05,4.24 C33.7075835,4.24 33.43,3.96241654 33.43,3.62 Z M41.18,5.88 L41.18,8.11 L40.06,8.11 L40.06,5.88 L41.18,5.88 Z M57.32,22.71 L54.82,16 C54.8219024,15.9767054 54.8219024,15.9532946 54.82,15.93 C54.7676992,15.4840836 54.3665211,15.1631411 53.92,15.21 L40.62,16.66 C28.04,15.28 31.09,14.19 30.69,21.46 C30.69,21.7085281 30.4885281,21.91 30.24,21.91 L27.66,21.91 C27.4245957,21.9102433 27.2307001,21.7251612 27.22,21.49 C27.22,21.39 26.52,12.38 26.53,12.49 C26.5268938,11.9779683 26.9110651,11.5463151 27.42,11.49 L40.62,10 L53.76,11.46 C54.2002165,11.473414 54.6118444,11.2425946 54.83,10.86 L57.32,3.4 C57.73,2.35 58.44,1.7 59.18,1.7 L63.77,1.7 L63.77,24.39 L59.18,24.39 C58.44,24.39 57.73,23.74 57.32,22.71 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M25,36.28 L25.63,33.71 C25.7199071,33.4190322 25.6411541,33.1022045 25.4254777,32.8871946 C25.2098013,32.6721847 24.8927314,32.5944128 24.6020432,32.6852201 C24.311355,32.7760273 24.0949359,33.0204543 24.04,33.32 L23.41,35.89 C23.3527777,36.1023693 23.3843771,36.3288779 23.497537,36.5174778 C23.610697,36.7060777 23.7956872,36.8405518 24.01,36.89 C24.0762547,36.900481 24.1437453,36.900481 24.21,36.89 C24.581008,36.8887988 24.9049872,36.6386376 25,36.28 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M23.06,39.94 L22.26,43.62 C22.2032296,43.8351997 22.2375079,44.0642776 22.3547846,44.2534335 C22.4720613,44.4425895 22.6620027,44.5751563 22.88,44.62 L23.06,44.62 C23.4411026,44.6190778 23.7700164,44.3526159 23.85,43.98 L24.65,40.3 C24.7125215,40.0159739 24.6187676,39.720168 24.4040545,39.5240098 C24.1893413,39.3278515 23.886289,39.2611419 23.6090544,39.3490098 C23.3318198,39.4368777 23.1225215,39.6659738 23.06,39.95 L23.06,39.94 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M26.13,30 L26.63,27.17 C26.6818035,26.8841875 26.5771928,26.5924491 26.3555737,26.4046797 C26.1339546,26.2169103 25.8289963,26.1616366 25.5555737,26.2596797 C25.2821511,26.3577227 25.0818035,26.5941875 25.03,26.88 L24.52,29.71 C24.4670525,29.9322891 24.5092611,30.1665894 24.6364523,30.356427 C24.7636435,30.5462645 24.9642792,30.6744186 25.19,30.71 L25.33,30.71 C25.7372314,30.7080872 26.0797285,30.4041211 26.13,30 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M33.74,33.32 C33.6850641,33.0204543 33.468645,32.7760273 33.1779568,32.6852201 C32.8872686,32.5944128 32.5701987,32.6721847 32.3545223,32.8871946 C32.1388459,33.1022045 32.0600929,33.4190322 32.15,33.71 L32.79,36.28 C32.8779925,36.6446682 33.2048679,36.9012033 33.58,36.9 C33.6429692,36.9096052 33.7070308,36.9096052 33.77,36.9 C33.9843128,36.8505518 34.169303,36.7160777 34.282463,36.5274778 C34.3956229,36.3388779 34.4272223,36.1123693 34.37,35.9 L33.74,33.32 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M33.14,40.29 L33.94,43.97 C34.0207558,44.3462999 34.3551513,44.6138163 34.74,44.61 L34.91,44.61 C35.128372,44.5648611 35.3189436,44.4327357 35.4378049,44.2440671 C35.5566661,44.0553984 35.5935651,43.8264593 35.54,43.61 L34.74,39.93 C34.6925618,39.7134708 34.559482,39.5253709 34.3710885,39.4085669 C34.182695,39.291763 33.9550384,39.2562063 33.74,39.31 C33.5301212,39.359784 33.3487678,39.4912243 33.2361379,39.6751865 C33.123508,39.8591486 33.0889054,40.0804364 33.14,40.29 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M32.76,26.81 C32.7050641,26.5104543 32.488645,26.2660273 32.1979568,26.1752201 C31.9072686,26.0844128 31.5901987,26.1621847 31.3745223,26.3771946 C31.1588459,26.5922045 31.0800929,26.9090322 31.17,27.2 L31.79,29.68 C31.8779925,30.0446682 32.2048679,30.3012033 32.58,30.3 C32.6463327,30.3094367 32.7136673,30.3094367 32.78,30.3 C32.9924688,30.2483018 33.1750094,30.112896 33.2861253,29.9245639 C33.3972412,29.7362319 33.4274917,29.5109749 33.37,29.3 L32.76,26.81 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M28,36 C28,36.4528735 28.3671265,36.82 28.82,36.82 C29.2728735,36.82 29.64,36.4528735 29.64,36 L29.64,33.43 C29.64,32.9771265 29.2728735,32.61 28.82,32.61 C28.3671265,32.61 28,32.9771265 28,33.43 L28,36 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M28,43.82 C28,44.2728735 28.3671265,44.64 28.82,44.64 C29.2728735,44.64 29.64,44.2728735 29.64,43.82 L29.64,40 C29.64,39.5471265 29.2728735,39.1800001 28.82,39.1800001 C28.3671265,39.1800001 28,39.5471265 28,40 L28,43.82 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M28.77,31 C29.2228735,31 29.59,30.6328735 29.59,30.18 L29.59,26.82 C29.59,26.3671265 29.2228735,26 28.77,26 C28.3171265,26 27.95,26.3671265 27.95,26.82 L27.95,30.21 C27.9661491,30.6511164 28.3285882,31.0002955 28.77,31 Z", id: "Shape" }),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M16.14,68.21 L16.34,68.21 C16.7464568,68.2005889 17.0846443,67.8947707 17.1347641,67.4913061 C17.1848839,67.0878415 16.9318003,66.7085735 16.54,66.6 C8.46,64.6 8.7,57.44 8.97,55.3 C8.97,55.3 8.97,55.19 8.97,55.16 C8.97591859,54.7294743 8.64002991,54.3714876 8.21,54.35 C7.76893822,54.3407261 7.39075207,54.6630438 7.33,55.1 C7.13,56.89 6.52,65.81 16.14,68.21 Z", id: "Shape" })
		)
	)
);

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 452 508", version: "1.1" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"g",
		{ id: "Page-1", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			"g",
			{ id: "noun_Shower_569664", fill: "#000000", "fill-rule": "nonzero" },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				"g",
				{ id: "Group" },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M230.1,16.4 L451.3,16.4 L451.3,0 L230.1,0 C204.6,0 189.1,45.5 189.1,65.5 L189.1,81.9 L148.1,81.9 L148.1,129.7 C78.1,149.4 11.7,216.3 17,319.5 L0.7,319.5 L0.7,335.9 L17,335.9 L377.7,335.9 L394,335.9 L394,319.5 L377.7,319.5 C383.1,219.5 322.1,151.2 246.5,129.7 L246.5,81.9 L205.5,81.9 L205.5,65.5 C205.5,47.7 219.7,16.4 230.1,16.4 Z M361.3,319.5 L33.4,319.5 C26.2,208.8 112.2,139.2 197.4,139.2 C287.7,139.3 368.4,213.6 361.3,319.5 Z M230.1,125.9 C219.5,123.9 208.5,122.9 197.3,122.9 C186.1,122.9 175.2,124 164.5,125.9 L164.5,98.3 L230,98.3 L230,125.9 L230.1,125.9 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "25.3", y: "368.7", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "90.8", y: "368.7", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "156.4", y: "368.7", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "221.9", y: "368.7", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "287.5", y: "368.7", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "353", y: "368.7", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "58", y: "426.1", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "123.6", y: "426.1", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "189.1", y: "426.1", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "254.7", y: "426.1", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "320.2", y: "426.1", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "90.8", y: "483.4", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "156.4", y: "483.4", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "221.9", y: "483.4", width: "16.4", height: "24.6" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("rect", { id: "Rectangle-path", x: "287.5", y: "483.4", width: "16.4", height: "24.6" })
			)
		)
	)
);

var _ref12 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 54 86", version: "1.1" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"g",
		{ id: "Page-1", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			"g",
			{ id: "noun_Refrigerator_1073105", transform: "translate(0.000000, -1.000000)", fill: "#000000", "fill-rule": "nonzero" },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				"g",
				{ id: "Group", transform: "translate(0.000000, 0.637820)" },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M5,0.36218 C2.247299,0.36218 0,2.60948 0,5.36218 L0,81.36218 C0,84.11488 2.247299,86.36218 5,86.36218 L49,86.36218 C51.752701,86.36218 54,84.11488 54,81.36218 L54,5.36218 C54,2.60948 51.752701,0.36218 49,0.36218 L5,0.36218 Z M5,2.36218 L49,2.36218 C50.679295,2.36218 52,3.68288 52,5.36218 L52,42.36218 L2,42.36218 L2,5.36218 C2,3.68288 3.320705,2.36218 5,2.36218 Z M43.875,14.33093 C43.3598842,14.3954753 42.9798022,14.8434292 43,15.36218 L43,29.36218 C42.9948997,29.7228159 43.1843753,30.0582614 43.4958728,30.2400677 C43.8073704,30.4218741 44.1926296,30.4218741 44.5041272,30.2400677 C44.8156247,30.0582614 45.0051003,29.7228159 45,29.36218 L45,15.36218 C45.011486,15.0684371 44.8931552,14.7845169 44.6764559,14.5858758 C44.4597566,14.3872348 44.1666376,14.2939927 43.875,14.33093 Z M2,44.36218 L52,44.36218 L52,81.36218 C52,83.04148 50.679295,84.36218 49,84.36218 L5,84.36218 C3.320705,84.36218 2,83.04148 2,81.36218 L2,44.36218 Z M43.875,56.33093 C43.3598842,56.3954753 42.9798022,56.8434292 43,57.36218 L43,71.36218 C42.9948997,71.7228159 43.1843753,72.0582614 43.4958728,72.2400677 C43.8073704,72.4218741 44.1926296,72.4218741 44.5041272,72.2400677 C44.8156247,72.0582614 45.0051003,71.7228159 45,71.36218 L45,57.36218 C45.011486,57.0684371 44.8931552,56.7845169 44.6764559,56.5858758 C44.4597566,56.3872348 44.1666376,56.2939927 43.875,56.33093 Z", id: "Shape" })
			)
		)
	)
);

var _ref13 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	"svg",
	{ viewBox: "0 0 42 54", version: "1.1" },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		"g",
		{ id: "Page-1", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			"g",
			{ id: "noun_Washing-Machine_564552", fill: "#000000", "fill-rule": "nonzero" },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				"g",
				{ id: "Group" },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M41,0.5 L1,0.5 C0.724,0.5 0.5,0.724 0.5,1 L0.5,51 C0.5,51.276 0.724,51.5 1,51.5 L41,51.5 C41.276,51.5 41.5,51.276 41.5,51 L41.5,1 C41.5,0.724 41.276,0.5 41,0.5 Z M40.5,1.5 L40.5,12.5 L1.5,12.5 L1.5,1.5 L40.5,1.5 Z M1.5,50.5 L1.5,13.5 L40.5,13.5 L40.5,50.5 L1.5,50.5 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M9,52.5 L5,52.5 C4.724,52.5 4.5,52.724 4.5,53 C4.5,53.276 4.724,53.5 5,53.5 L9,53.5 C9.276,53.5 9.5,53.276 9.5,53 C9.5,52.724 9.276,52.5 9,52.5 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M37,52.5 L33,52.5 C32.724,52.5 32.5,52.724 32.5,53 C32.5,53.276 32.724,53.5 33,53.5 L37,53.5 C37.276,53.5 37.5,53.276 37.5,53 C37.5,52.724 37.276,52.5 37,52.5 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M21,18.5 C13.005,18.5 6.5,25.005 6.5,33 C6.5,40.995 13.005,47.5 21,47.5 C28.995,47.5 35.5,40.995 35.5,33 C35.5,25.005 28.995,18.5 21,18.5 Z M21,46.5 C13.556,46.5 7.5,40.444 7.5,33 C7.5,25.556 13.556,19.5 21,19.5 C28.444,19.5 34.5,25.556 34.5,33 C34.5,40.444 28.444,46.5 21,46.5 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M21,22.5 C15.21,22.5 10.5,27.21 10.5,33 C10.5,38.79 15.21,43.5 21,43.5 C26.79,43.5 31.5,38.79 31.5,33 C31.5,27.21 26.79,22.5 21,22.5 Z M21,42.5 C15.762,42.5 11.5,38.238 11.5,33 C11.5,27.762 15.762,23.5 21,23.5 C26.238,23.5 30.5,27.762 30.5,33 C30.5,38.238 26.238,42.5 21,42.5 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M21,26.5 C20.724,26.5 20.5,26.724 20.5,27 C20.5,27.276 20.724,27.5 21,27.5 C24.032,27.5 26.5,29.968 26.5,33 C26.5,33.276 26.724,33.5 27,33.5 C27.276,33.5 27.5,33.276 27.5,33 C27.5,29.416 24.584,26.5 21,26.5 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M21,36.5 C19.07,36.5 17.5,34.93 17.5,33 C17.5,32.724 17.276,32.5 17,32.5 C16.724,32.5 16.5,32.724 16.5,33 C16.5,35.481 18.519,37.5 21,37.5 C21.276,37.5 21.5,37.276 21.5,37 C21.5,36.724 21.276,36.5 21,36.5 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M27,9.5 C28.379,9.5 29.5,8.378 29.5,7 C29.5,5.622 28.379,4.5 27,4.5 C25.621,4.5 24.5,5.622 24.5,7 C24.5,8.378 25.621,9.5 27,9.5 Z M27,5.5 C27.827,5.5 28.5,6.173 28.5,7 C28.5,7.827 27.827,8.5 27,8.5 C26.173,8.5 25.5,7.827 25.5,7 C25.5,6.173 26.173,5.5 27,5.5 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M35,9.5 C36.379,9.5 37.5,8.378 37.5,7 C37.5,5.622 36.379,4.5 35,4.5 C33.621,4.5 32.5,5.622 32.5,7 C32.5,8.378 33.621,9.5 35,9.5 Z M35,5.5 C35.827,5.5 36.5,6.173 36.5,7 C36.5,7.827 35.827,8.5 35,8.5 C34.173,8.5 33.5,7.827 33.5,7 C33.5,6.173 34.173,5.5 35,5.5 Z", id: "Shape" }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("path", { d: "M5,9.5 L17,9.5 C17.276,9.5 17.5,9.276 17.5,9 L17.5,5 C17.5,4.724 17.276,4.5 17,4.5 L5,4.5 C4.724,4.5 4.5,4.724 4.5,5 L4.5,9 C4.5,9.276 4.724,9.5 5,9.5 Z M5.5,5.5 L16.5,5.5 L16.5,8.5 L5.5,8.5 L5.5,5.5 Z", id: "Shape" })
			)
		)
	)
);

var getGlyph = function getGlyph(id) {
	switch (id) {
		case 'checkmark':
			return _ref;
		case 'close':
			return _ref2;
		case 'questionmark':
			return _ref3;
		case 'logo':
			return _ref4;
		case 'loader':
			return _ref5;
		case 'bath':
			return _ref6;
		case "dishwasher":
			return _ref7;
		case "garden_hose":
			return _ref8;
		case "kitchen_fauce":
			return _ref9;
		case "bathroom_faucet":
			return _ref10;
		case "shower":
			return _ref11;
		case "refrigerator_water_dispenser":
			return _ref12;
		case "washing_machine":
			return _ref13;
		default:
			return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				"p",
				null,
				"No glyph supplied for ",
				id,
				"."
			);
	}
};

/***/ }),

/***/ "QAmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = typeof fetch == 'function' ? fetch.bind() : function (url, options) {
	options = options || {};
	return new Promise(function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url, true);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials == 'include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body);

		function response() {
			var _keys = [],
			    all = [],
			    headers = {},
			    header;

			request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (m, key, value) {
				_keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? header + "," + value : value;
			});

			return {
				ok: (request.status / 100 | 0) == 2, // 200-299
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function text() {
					return Promise.resolve(request.responseText);
				},
				json: function json() {
					return Promise.resolve(request.responseText).then(JSON.parse);
				},
				blob: function blob() {
					return Promise.resolve(new Blob([request.response]));
				},
				headers: {
					keys: function keys() {
						return _keys;
					},
					entries: function entries() {
						return all;
					},
					get: function get(n) {
						return headers[n.toLowerCase()];
					},
					has: function has(n) {
						return n.toLowerCase() in headers;
					}
				}
			};
		}
	});
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=unfetch.es.js.map

/***/ }),

/***/ "bZpv":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Edge 14's fetch implementation is a buggy mess
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8653298/
 */
if (window.navigator.userAgent.indexOf('Edge/14') > -1) delete window.fetch;

module.exports = window.fetch || __webpack_require__("QAmr").default || __webpack_require__("QAmr");

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "l262":
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "ljlK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FadeCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
var _class, _temp2;



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var FadeCard = (_temp2 = _class = function (_Component) {
	_inherits(FadeCard, _Component);

	function FadeCard() {
		var _temp, _this, _ret;

		_classCallCheck(this, FadeCard);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			current: 0
		}, _this.nextCard = function () {
			var _this$props = _this.props,
			    change = _this$props.change,
			    finish = _this$props.finish;

			if (change) {
				change(_this.state.current, _this.props.children.length);
			}
			if (_this.state.current + 1 === _this.props.children.length) {
				if (finish) {
					finish();
				}
			} else {
				_this.setState({ current: _this.state.current + 1 });
			}
		}, _this.shouldShow = function (index, current) {
			if (index === current) return true;
			if (index < current && index === current - 1) return true;
			if (index > current && index === current + 1) return true;
			return false;
		}, _this.getClass = function (index, current) {
			if (index === current) {
				return 'current';
			}
			if (index < current) {
				return 'past';
			}
			if (index > current) {
				return 'future';
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	FadeCard.prototype.render = function render() {
		var _this2 = this;

		var current = this.state.current;
		var _props = this.props,
		    counter = _props.counter,
		    height = _props.height,
		    counterDelimiter = _props.counterDelimiter;
		var nextCard = this.nextCard;


		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ className: 'fade-container card', ref: function ref(node) {
					return _this2.container = node;
				}, style: { height: height } },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ className: 'fade-region' },
				this.props.children.map(function (child, index) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ className: 'fade-region__card ' + _this2.getClass(index, current) },
						_this2.shouldShow(index, current) && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(child, { nextCard: nextCard, activeCard: index === current, lastCard: index === _this2.props.children.length - 1 })
					);
				})
			),
			counter && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ className: 'counter' },
				current + 1,
				' ',
				counterDelimiter,
				' ',
				this.props.children.length
			)
		);
	};

	return FadeCard;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.defaultProps = {
	counter: false,
	counterDelimiter: '/'
}, _temp2);


/***/ }),

/***/ "mV6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SKIP_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MOBILE_BREAKPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AGREE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QUESTIONS; });
var USER_ID = 'userId';

// export const SKIP_START = true;
var SKIP_START = false;

var LAYOUT_TYPES = ['full', 'full-color', 'question-left', 'question-right'];

var MOBILE_BREAKPOINT = 600;

var AGREE_OPTIONS = [{ label: 'Strongly Disagree', value: 'strongly_disagree' }, { label: 'Disagree', value: 'disagree' }, { label: 'Agree', value: 'agree' }, { label: 'Strongly Agree', value: 'strongly_agree' }];

var agreeSort = ['strongly_disagree', 'disagree', 'agree', 'strongly_agree'];

var QUESTIONS = [{
	id: 'cq_1',
	label: 'Question One',
	question: 'Do you think about the amount of water you use at home?',
	type: 'yes-no',
	layout: 'question-left',
	options: [{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }, { label: 'Don\'t know', value: 'unsure' }],
	sortOrder: ['yes', 'no', 'unsure'],
	image: 'cq_1-min.jpg'
}, {
	id: 'cq_2',
	label: 'Question Two',
	question: 'What is your first interaction with water when you wake up?',
	type: 'radios',
	layout: 'full-color',
	options: [{ label: "Drink water", value: "drink_water" }, { label: "Shower / Bath", value: "shower_bath" }, { label: "Make Coffee / Tea", value: "coffee_tea" }, { label: "Wash Face", value: "wash_face" }, { label: "Brush Teeth", value: "brush_teeth" }, { label: "Flush Toilet", value: "flush_toilet" }, { label: "Don't Know / Not Sure", value: "dont_know" }],
	image: 'cq_2-min.jpg'
}, {
	id: 'cq_3',
	label: 'Question Three',
	question: 'How many interactions with water do you think you have throughout the day?',
	type: 'input',
	layout: 'full',
	sortOrder: ['<4', '5-7', '8-11', '12-15', '16+'],
	option: 'I have {input} interactions with water throughout my day.'
}, {
	id: 'cq_4',
	label: 'Question Four',
	question: 'What time of day do you use the most water?',
	type: 'time-selector',
	layout: 'question-right',
	options: [{ label: 'Early Morning', value: 'early_morning' }, { label: 'Morning', value: 'morning' }, { label: 'Afternoon', value: 'afternoon' }, { label: 'Late Afternoon', value: 'late_afternoon' }, { label: 'Evening', value: 'evening' }, { label: 'Late Evening', value: 'late_evening' }],
	sortOrder: ['early_morning', 'morning', 'afternoon', 'late_afternoon', 'evening', 'late_evening'],
	image: 'cq_4-min.jpg'
}, {
	id: 'cq_5',
	label: 'Question Five',
	question: 'What role does water play?',
	header: 'Water...',
	type: 'multi-agree',
	layout: 'question-left',
	options: [{
		"subQuestion": "brings me comfort",
		"id": "cq_5_1",
		sortOrder: agreeSort
	}, {
		"subQuestion": "brings my family together",
		"id": "cq_5_2",
		sortOrder: agreeSort
	}, {
		"subQuestion": "brings me close to loved ones",
		"id": "cq_5_3",
		sortOrder: agreeSort
	}, {
		"subQuestion": "is an important part of my daily routine",
		"id": "cq_5_4",
		sortOrder: agreeSort
	}, {
		"subQuestion": "is important to my overall health and well-being",
		"id": "cq_5_5",
		sortOrder: agreeSort
	}, {
		"subQuestion": "can change my mood (e.g. uplift or calm me)",
		"id": "cq_5_6",
		sortOrder: agreeSort
	}, {
		"subQuestion": "relaxes me",
		"id": "cq_5_7",
		sortOrder: agreeSort
	}, {
		"subQuestion": "brings me a feeling of safety",
		"id": "cq_5_8",
		sortOrder: agreeSort
	}, {
		"subQuestion": "brings me joy",
		"id": "cq_5_9",
		sortOrder: agreeSort
	}, {
		"subQuestion": "is something I worry about",
		"id": "cq_5_10",
		sortOrder: agreeSort
	}, {
		"subQuestion": "is something I take for granted",
		"id": "cq_5_11",
		sortOrder: agreeSort
	}, {
		"subQuestion": "is something I am grateful for",
		"id": "cq_5_12",
		sortOrder: agreeSort
	}],
	image: 'cq_5-min.jpg'
}, {
	id: 'cq_6',
	label: 'Question Six',
	question: 'What is the single most important source of water in your home?',
	type: 'svg-chooser',
	layout: 'full',
	options: [{
		label: 'Kitchen faucet',
		value: 'kitchen_fauce'
	}, {
		label: 'Bathroom faucet',
		value: 'bathroom_faucet'
	}, {
		label: 'Shower',
		value: 'shower'
	}, {
		label: 'Bath',
		value: 'bath'
	}, {
		label: 'Refrigerator water dispenser',
		value: 'refrigerator_water_dispenser'
	}, {
		label: 'Dishwasher',
		value: 'dishwasher'
	}, {
		label: 'Washing Machine',
		value: 'washing_machine'
	}, {
		label: 'Garden hose',
		value: 'garden_hose'
	}]
}, {
	id: 'cq_7',
	label: 'Question Seven',
	question: 'Do you agree or disagree?',
	type: 'multi-agree',
	layout: 'question-left',
	options: [{
		"question": "I would like to find ways to reduce my water usage at home",
		"id": "cq_7_1",
		sortOrder: agreeSort
	}, {
		"question": "I feel safe drinking water from the faucet at home",
		"id": "cq_7_2",
		sortOrder: agreeSort
	}, {
		"question": "I feel guilty about how much water I use",
		"id": "cq_7_3",
		sortOrder: agreeSort
	}, {
		"question": "Friends or family have judged me for how much water I use",
		"id": "cq_7_4",
		sortOrder: agreeSort
	}, {
		"question": "I feel pretty knowledgeable about water issues and conservation",
		"id": "cq_7_5",
		sortOrder: agreeSort
	}, {
		"question": "As I get older, I feel more responsible for the water I use",
		"id": "cq_7_6",
		sortOrder: agreeSort
	}, {
		"question": "I feel responsible for the amount of water I use outside my home",
		"id": "cq_7_7",
		sortOrder: agreeSort
	}, {
		"question": "I am tuned into the environmental issues facing our world  ",
		"id": "cq_7_8",
		sortOrder: agreeSort
	}, {
		"question": "I understand where my water comes from ",
		"id": "cq_7_9",
		sortOrder: agreeSort
	}, {
		"question": "I know how much my water usage costs ",
		"id": "cq_7_10",
		sortOrder: agreeSort
	}, {
		"question": "I trust the government to responsibly manage society’s water use/consumption",
		"id": "cq_7_11",
		sortOrder: agreeSort
	}, {
		"question": "I wish I had more control over my water usage in the home",
		"id": "cq_7_12",
		sortOrder: agreeSort
	}],
	image: 'cq_7-min.jpg'
}, {
	id: 'video-screen',
	type: 'screen'
}];

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "ukFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LazyBackground; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", { className: "overlay fill" });

var LazyBackground = function (_Component) {
	_inherits(LazyBackground, _Component);

	function LazyBackground() {
		var _temp, _this, _ret;

		_classCallCheck(this, LazyBackground);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			image: null
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	LazyBackground.prototype.componentDidMount = function componentDidMount() {
		var self = this;
		var image = new Image();
		image.src = this.props.image;
		image.onload = function () {
			self.setState({ image: true });
			// var canvas = document.createElement('CANVAS');
			// var ctx = canvas.getContext('2d');
			// var dataURL;
			// canvas.height = this.naturalHeight;
			// canvas.width = this.naturalWidth;
			// ctx.drawImage(this, 0, 0);
			// dataURL = canvas.toDataURL();
			// self.setState({ image: dataURL });
		};
	};

	LazyBackground.prototype.render = function render() {
		var style = void 0;
		if (this.state.image) {
			style = {
				// backgroundImage: `url(${this.state.image})`
				backgroundImage: "url(" + this.props.image + ")"
			};
		}
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			"div",
			{ className: "lazy-background background" },
			this.state.image && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", { className: "cover fill", style: style }),
			this.props.overlay && _ref,
			this.props.children && this.props.children
		);
	};

	return LazyBackground;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "x4D6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export trackEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackButtonClick; });
var trackEvent = function trackEvent(event) {
	// console.log('gtm:event', event);
	dataLayer.push({ event: event });
};

var trackScreen = function trackScreen(screenName) {
	// console.log('trackingScreen', screenName);
	ga('send', 'screenview', { screenName: screenName });
};

var trackButtonClick = function trackButtonClick(event) {
	// console.log('trackButtonClick', event);
	ga('send', 'event', 'Button', 'click', event);
};

/***/ }),

/***/ "yY49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.a5e56.js